import { useState, useEffect, useCallback } from "react";

function useStorage(keyPrefix: string, defaultValue: any, dependencies: any[] = []) {
  // Initialize state
  const [value, setValue] = useState(defaultValue);
  const [key, setKey] = useState<string | null>(null);

  useEffect(() => {
    // Generate the key only if all dependencies are defined
    if (!dependencies.some((dep) => dep === undefined)) {
      setKey([keyPrefix, ...dependencies].join("-"));
    }
  }, [keyPrefix, dependencies]);

  useEffect(() => {
    if (key !== null) {
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        console.log("overriding value with stored value", storedValue);
        setValue(JSON.parse(storedValue));
      }
    }
  }, [key, defaultValue]);

  useEffect(() => {
    if (key !== null) {
      const storedValue = localStorage.getItem(key);
      if (value !== null && value !== undefined && storedValue !== value)
        localStorage.setItem(key, JSON.stringify(value));
    }
  }, [key, value]);

  // Handle changes in localStorage from other tabs or windows
  const handleStorageChange = useCallback(
    (event: StorageEvent) => {
      if (event.key === key && event.newValue) {
        try {
          const newValue = JSON.parse(event.newValue);
          setValue(newValue);
        } catch (e) {
          console.error(`Error parsing newValue ${event.newValue} for key: ${key}`, e);
        }
      }
    },
    [key, defaultValue]
  );

  // Add and clean up the storage event listener
  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [handleStorageChange]);

  // Update value function
  const updateValue = (newValue: any) => {
    if (key !== null) {
      setValue(newValue);
    }
  };

  return [key === null ? undefined : value, updateValue];
}

export default useStorage;
